var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selected)?_c('toolbar-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected.length == 1),expression:"selected.length == 1"}],attrs:{"icon":"mdi-folder-edit-outline","tooltip":"Rename selected folder, only one folder","button":{ disabled: _vm.selected.length != 1 }},on:{"click":_vm.renameFolderModal}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }